import React, { useState } from "react";
import { Checkbox, Modal, Typography } from "antd";
import { useMailTranslation } from "../useMailTranslation";

const { Paragraph } = Typography;

/** Explains what leaves the server before the assistant is switched on for a mailbox. */
const AssistantConsentModal = ({ open, email, onConfirm, onCancel }) => {
  const { t } = useMailTranslation();
  const [agreed, setAgreed] = useState(false);
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try {
      await onConfirm();
      setAgreed(false);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      open={open}
      title={t("Turn on the mail assistant")}
      okText={t("Turn on")}
      cancelText={t("Cancel")}
      okButtonProps={{ disabled: !agreed, loading: busy }}
      onOk={confirm}
      onCancel={onCancel}
      destroyOnClose
    >
      <Paragraph>
        {t(
          "The assistant sorts your emails by topic and urgency, suggests replies and files attachments in your document directory."
        )}
      </Paragraph>
      <Paragraph>
        {t(
          "To do this, the content of the emails you choose to analyse, including PDF and image attachments, is sent to the AI provider Anthropic (Claude). Nothing is analysed until you click Analyse, and nothing is sent, moved or saved without your confirmation."
        )}
      </Paragraph>
      <Paragraph type="secondary">
        {t(
          "Emails contain personal data of your customers. Make sure your privacy policy and your data processing agreements cover this before you turn the assistant on."
        )}
      </Paragraph>
      <Checkbox checked={agreed} onChange={event => setAgreed(event.target.checked)}>
        {t("I agree that emails of {{email}} may be analysed this way.", { email })}
      </Checkbox>
    </Modal>
  );
};

export default AssistantConsentModal;
